import { Autocomplete, Box, TextField } from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";
import { getUserType } from "util/auth";
import useStoreSearch from "../hooks/useStoreSearch";

// type IncrementalProps = {
//   label: string;
//   options: string[];
//   value: string;
//   onChange: (newValue: string) => void;
//   optionLength?: number;
//   multiple?: boolean;
//   fullWidth?: boolean;
//   isLoading?: boolean;
// };

type Props = {
  value: string; // storeCd
  setValue: Dispatch<SetStateAction<string>>; // setStoreCdなどのセット関数
  setTarget?: Dispatch<SetStateAction<number | undefined>>; // ターゲットのセット関数
}

/**
 * インクリメンタルサーチ
 * @param root0 props
 * @returns JSX.Element
 */
export default function IncrementalSearchElement({value, setValue, setTarget}: Props) {
  const { isLoading, stores } = useStoreSearch();
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");

  return (
    <Box m={1} width="calc(50% - 16px)">
      <Autocomplete
        options={stores.map((s) => s.store_name)}
        open={open}
        onOpen={() => {
          if (inputValue.trim() !== "") {
            setOpen(true);
          }
        }}
        onClose={() => setOpen(false)}
        inputValue={inputValue}
        onInputChange={(_e, newval) => {
          setInputValue(newval);
          setOpen(newval.trim() !== "");
        }}
        value={stores.find(s => s.client_cd === value)?.store_name ?? ""}
        // freeSolo
        // clearOnBlur={false}
        // autoHighlight={false}
        // blurOnSelect="mouse"
        // disableClearable
        // clearIcon={null}
        popupIcon={null}
        // noOptionsText=""
        disabled={isLoading}
        // filterOptions={(options, { inputValue }) => (inputValue.trim() === "" ? [] : options)}
        onChange={(_event, newClientName) => {
          // setStoreTargetApiParams((prev) => ({
          //   ...prev,
          //   clientName: newClientName ?? "",
          // }));
          const store = stores.find(s => s.store_name === newClientName);
          const clientCd = store?.client_cd ?? "";
          setValue(clientCd); // 本部ユーザー、YH店舗指定の場合もclientCd指定と仮定
          // 現在のユーザー種別からレポートのtargetを割り出す。
          const userType = getUserType();
          if (setTarget) {
            if (!store) {
              // 店舗が選択されていないとき
              if (userType === "C0001") {
                setTarget(4); // 本部が対象
              } else if (userType === "C0006") {
                setTarget(3); // 企業が対象
              } else if (userType === "C0002") {
                setTarget(1); // 店舗が対象
              } else if (userType === "C0003") {
                setTarget(2); // 得意先が対象
              }
            } else if (userType === "C0001" || userType === "C0006") {
              // 店舗が選択されている時
              setTarget(store.is_client ? 2 : 1);
            } else {
              // 店舗や得意先だけど店舗を指定している場合など（ここは通らないが正）
              setTarget(undefined);
            }
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="店舗名"
            inputProps={{ ...params.inputProps, maxLength: 100 }}
          />
        )}
      />
    </Box>
  );
}
